class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var cart_content = JSON.parse(document.querySelector('#cart-items-content').textContent);
      let updates =''      
      const bundleItem = event.target.closest('.cart-item').dataset.properties;
      if(bundleItem) {
        const bundleItems = cart_content.items.filter(item => item.properties._bundle_pack == bundleItem ? item.properties._bundle_pack == bundleItem : item.properties._cb_number == bundleItem);
        updates = bundleItems.reduce((acc, item) => {
          acc[item.key] = 0;
          return acc;
        }, {});
        this.closest('cart-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), updates);
      } else {
        this.closest('cart-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'));
      }
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    if(event.target.dataset.index){
      var cart_content = JSON.parse(document.querySelector('#cart-items-content').textContent);
      let updates =''
      const bundleItem = event.target.closest('.cart-item').dataset.properties;
       if(bundleItem) {
        const bundleItems = cart_content.items.filter(item => item.properties._bundle_pack == bundleItem ? item.properties._bundle_pack == bundleItem : item.properties._cb_number == bundleItem);
        updates = bundleItems.reduce((acc, item) => {
          acc[item.key] = event.target.value;
          return acc;
        }, {});
        this.closest('cart-items').updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), updates);
      } else {
        this.closest('cart-items').updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
      }
      
      // console.log(updates)
      // this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), updates);
    }
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name, updates) {
    console.log('test')
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);
    var body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });
    var url = window.routes.cart_change_url;
    
    let values = [];
    if (updates) {
      values = Object.values(updates);
    }

    if (values.length) {
      url = window.routes.cart_update_url;
      body = JSON.stringify({
        updates,
        sections: sections,
        sections_url: window.location.pathname
      });
    }
    fetch(`${url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const _this = this
        const cartData = JSON.parse(state);
        console.log(cartData, 'state');
        const free_gift = window.min_gift.free_git;
        const minPrice = window.min_gift.min_price;
        const fpCollection = window.min_gift.fpc_collection;
        const isGiftAdded = cartData.items.some(item => item.id == free_gift); 
        const fpvarinat = window.min_gift.qualifyingVariants;
        const useVariants = window.min_gift.use_varinats;
        
        console.log('sloadeddddd')
        var newData = cartData;
        const parsedDocument = new DOMParser().parseFromString(newData.sections['mini-cart'], 'text/html');
        const cartLineItemHTML = parsedDocument.querySelector('#main-cart-items');
        const itemWithAfpc = Array.from(cartLineItemHTML.querySelectorAll('li')).find(
          (item) => item.dataset.afpc == 1
        );
      
        const cartTotalExcludingGiftCard = cartData.items
        .filter(item => item.handle != "gift-card") 
        .reduce((total, item) => total + item.line_price, 0); 
    
        

        if (useVariants && cartTotalExcludingGiftCard >= minPrice  && free_gift != 0 ) {
          const hasMatchingVariant = cartData.items.some((item) => fpvarinat.includes(item.id.toString()));
        
          if (hasMatchingVariant && !isGiftAdded) {
            var items = [
              {
                quantity: 1,
                id: parseInt(free_gift),
                properties: {
                  _min_gift_product: true
                }
              }
            ]
          
            console.log(free_gift,"free_giftfree_gift");
  
            fetch(`${window.routes.cart_add_url}.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
              },
              body: JSON.stringify({
                items,
                sections: sections,
                sections_url: window.location.pathname
              })
            })
            .then((response) => response.json())
            .then((response) => {
              console.log(response, 'Adding response');
              cartChangeSucess(_this, response);
            });
            return;
          }
          else {
            cartChangeSucess(_this, cartData);
            console.log('removed matches');
          }
        }
        else  if(fpCollection == 0 && cartTotalExcludingGiftCard >= minPrice  && free_gift != 0) {
            if(!isGiftAdded){
              var items = [
                {
                  quantity: 1,
                  id: parseInt(free_gift),
                  properties: {
                    _min_gift_product: true
                  }
                }
              ]
              
              fetch(`${window.routes.cart_add_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                body: JSON.stringify({
                  items,
                  sections: sections,
                  sections_url: window.location.pathname
                })
              })
              .then((response) => response.json())
              .then((response) => {
               console.log(response, 'response 2')
                cartChangeSucess(_this, response);
              })
            } else {
              var cartPrice = cartTotalExcludingGiftCard 
                if(cartPrice <= minPrice  && free_gift != 0) {
                  const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
                  if(giftItem.length){
                    fetch(`${window.routes.cart_change_url}.js`, {
                     method: 'POST',
                     credentials: 'same-origin',
                     headers: {
                       'Content-Type': 'application/json',
                       'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                     },
                     body: JSON.stringify({
                       'id': giftItem[0].key,
                       'quantity': 0,
                       sections: sections,
                       sections_url: window.location.pathname
                     })
                   })
                   .then((response) => response.json())
                   .then((response) => {
                    console.log(response, 'response m')
                     cartChangeSucess(_this, response);
                   })
                  }
                } else {
                  cartChangeSucess(_this, cartData);
                }
            } 
          } else if (itemWithAfpc) {
            if (!isGiftAdded  && free_gift != 0) {
            console.log('let fire')
              var items = [
                {
                  quantity: 1,
                  id: parseInt(free_gift),
                  properties: {
                    _min_gift_product: true
                  }
                }
              ]
              // console.log(items, 'items')
              fetch(`${window.routes.cart_add_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                body: JSON.stringify({
                  items,
                  sections: sections,
                  sections_url: window.location.pathname
                })
              })
              .then((response) => response.json())
              .then((response) => {
                // console.log(response, 'response')
                cartChangeSucess(_this, response);
              })
            } else {
              cartChangeSucess(_this, cartData);
            }
          } else {
             const giftItem = cartData.items.filter(item => item.properties?._min_gift_product == true);
             if(giftItem.length){
               fetch(`${window.routes.cart_change_url}.js`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                body: JSON.stringify({
                  'id': giftItem[0].key,
                  'quantity': 0,
                  sections: sections,
                  sections_url: window.location.pathname
                })
              })
              .then((response) => response.json())
              .then((response) => {
                // console.log(response, 'response')
                cartChangeSucess(_this, response);
              })
             } else {
              cartChangeSucess(_this, cartData);
             }

          } 
        
        
          function cartChangeSucess(_this, parsedState) {
            // console.log(parsedState, 'parsedState', 'Checking cart change success');
            
            _this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');
          
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (parsedState.errors) {
              _this.updateErrorLiveRegions(line, parsedState.errors);
            }
            _this.getSectionsToRender().forEach((section) => {
              const element = document.getElementById(section.id);
              if (element) {
                const elementToReplace = element.querySelector(section.selector) || element;
          
                if (elementToReplace && parsedState.sections[section.section]) {
                  elementToReplace.innerHTML = _this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
              }
            });
            
            if (useVariants) {
              const hasMatchingVariant = parsedState.items.some((item) => fpvarinat.includes(item.id.toString()));
              const giftItem = parsedState.items.find((item) => item.properties?._min_gift_product === true);
          
              if (!hasMatchingVariant && giftItem) {
                fetch(`${window.routes.cart_change_url}.js`, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                  },
                  body: JSON.stringify({
                    id: giftItem.key,
                    quantity: 0,
                    sections: sections,
                    sections_url: window.location.pathname
                  })
                })
                .then((response) => response.json())
                .then((response) => {
                  // console.log(response, 'Free gift removed');
                  cartChangeSucess(_this, response); // Update cart after removal
                });
              }
            }
            
            _this.updateQuantityLiveRegions(line, parsedState.item_count);
          
            const lineItem = document.getElementById(`CartItem-${line}`);
            if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
            _this.disableLoading();
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: parsedState
              }
            }));
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
          }
                    
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }

  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;

    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('mini-cart');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const cartItems2 = document.getElementById('main-cart-items');
    if (cartItems2) cartItems2.classList.add('cart__items--disabled');
    
    const cartItems3 = document.getElementById('main-cart-footer'); 
    if (cartItems3) cartItems3.classList.add('cart_footer__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('mini-cart');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
    
    const cartItems2 = document.getElementById('main-cart-items');
    if (cartItems2) cartItems2.classList.remove('cart__items--disabled');

    const cartItems3 = document.getElementById('main-cart-footer');
     if (cartItems3) cartItems3.classList.remove('cart_footer__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}

customElements.define('cart-items', CartItems);
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${window.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);
